document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.menu-button');
  const nav = document.querySelector('.main-nav');
  const cartButton = document.querySelector('[data-cart-open]');
  const cartDrawer = document.querySelector('#ZenbarCartDrawer');
  const closeCart = document.querySelector('.close-cart');
  const overlay = document.querySelector('.overlay');
  const toast = document.querySelector('.toast');
  const cartCountNodes = document.querySelectorAll('[data-cart-count]');
  const cartItemsNode = document.querySelector('[data-cart-drawer-items]');
  const cartSubtotal = document.querySelector('[data-cart-subtotal]');
  const routeRoot = (window.Zenbar?.root || '/').replace(/\/?$/, '/');
  const cartService = window.createDruzelCart({
    request: window.fetch.bind(window),
    guideId: window.Zenbar?.guideId,
    root: routeRoot,
    lock: navigator.locks ? task => navigator.locks.request('druzel-cart-guide', task) : null
  });
  let cartPageQueue = Promise.resolve();
  function cartError(error) {
    document.querySelectorAll('[data-cart-guide-status]').forEach(node => { node.textContent = error.message || 'Your bag could not be updated. Please try again.'; });
    showToast('Your bag could not be updated. Please try again.');
  }
  function clearCartError() {
    document.querySelectorAll('[data-cart-guide-status]').forEach(node => { node.textContent = ''; });
  }

  const money = cents => new Intl.NumberFormat('en-CA', { style: 'currency', currency: window.Zenbar?.currency || 'CAD' }).format(cents / 100);
  const escapeHtml = value => String(value || '').replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));

  const submenuToggles = document.querySelectorAll('.submenu-toggle');
  const columnToggles = document.querySelectorAll('.mega-menu__column-toggle');

  const closeSubmenus = () => {
    document.querySelectorAll('.nav-item.submenu-open').forEach(item => item.classList.remove('submenu-open'));
    submenuToggles.forEach(button => button.setAttribute('aria-expanded', 'false'));
    document.querySelectorAll('.mega-menu__column.column-open').forEach(column => column.classList.remove('column-open'));
    columnToggles.forEach(button => button.setAttribute('aria-expanded', 'false'));
  };

  const closeNav = () => {
    nav?.classList.remove('open');
    menuButton?.setAttribute('aria-expanded', 'false');
    menuButton?.setAttribute('aria-label', 'Open navigation');
    closeSubmenus();
  };

  if (menuButton && nav) {
    menuButton.addEventListener('click', () => {
      const open = nav.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      if (!open) closeSubmenus();
    });

    submenuToggles.forEach(button => button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      const item = button.closest('.nav-item');
      if (!item) return;
      document.querySelectorAll('.nav-item.submenu-open').forEach(other => {
        if (other !== item) {
          other.classList.remove('submenu-open');
          other.querySelector('.submenu-toggle')?.setAttribute('aria-expanded', 'false');
        }
      });
      const open = item.classList.toggle('submenu-open');
      button.setAttribute('aria-expanded', String(open));
    }));

    columnToggles.forEach(button => button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      const column = button.closest('.mega-menu__column');
      if (!column) return;
      const open = column.classList.toggle('column-open');
      button.setAttribute('aria-expanded', String(open));
    }));

    nav.querySelectorAll('a').forEach(link => link.addEventListener('click', closeNav));
    document.addEventListener('click', event => {
      if (!nav.contains(event.target) && event.target !== menuButton) closeSubmenus();
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeNav();
    });
  }

  function openCart() {
    if (!cartDrawer || !overlay) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    document.body.classList.add('drawer-open');
    closeCart?.focus();
  }
  function hideCart() {
    if (!cartDrawer || !overlay) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.classList.remove('drawer-open');
  }
  cartButton?.addEventListener('click', event => { event.preventDefault(); openCart(); refreshCart(true).catch(cartError); });
  closeCart?.addEventListener('click', hideCart);
  overlay?.addEventListener('click', hideCart);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') hideCart(); });

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    window.setTimeout(() => toast.classList.remove('show'), 1900);
  }

  function renderCart(cart) {
      clearCartError();
      cartCountNodes.forEach(node => node.textContent = cart.item_count);
      if (cartSubtotal) cartSubtotal.textContent = money(cart.total_price);
      cartDrawer?.classList.toggle('cart-drawer--empty', cart.items.length === 0);
      if (!cartItemsNode) return cart;
      if (!cart.items.length) {
        cartItemsNode.innerHTML = `
          <div class="cart-drawer__empty">
            <div class="cart-drawer__empty-gem" aria-hidden="true"><span>✦</span></div>
            <h3>A little space for something special</h3>
            <p>Your bag is waiting for a natural treasure chosen just for you.</p>
            <a class="button primary cart-drawer__shop-link" href="/collections/all">Continue shopping</a>
          </div>`;
        return cart;
      }
      const sortedItems = [...cart.items].sort((a,b) => Number(cartService.isGuide(b)) - Number(cartService.isGuide(a)));
      cartItemsNode.innerHTML = sortedItems.map(item => `
        <article class="drawer-item${cartService.isGuide(item) ? ' drawer-item--guide' : ''}">
          <a class="drawer-item__image" href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">` : '<span aria-hidden="true">✦</span>'}</a>
          <div class="drawer-item__details">
            <a class="drawer-item__title" href="${escapeHtml(item.url)}"><h3>${escapeHtml(item.product_title)}</h3></a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="drawer-item__variant">${escapeHtml(item.variant_title)}</p>` : ''}
            ${cartService.isGuide(item) ? '<p class="cart-guide-label">Complimentary digital gift · Included</p>' : ''}
            <div class="drawer-item__meta">
              <strong>${money(item.final_line_price)}</strong>
              <span>Qty ${item.quantity}</span>
            </div>
            ${cartService.isGuide(item) ? '<p class="cart-guide-note">PDF download emailed after checkout. Nothing to ship.</p>' : `<button class="drawer-remove" type="button" data-remove-key="${escapeHtml(item.key)}">Remove</button>`}
          </div>
        </article>`).join('');
      cartItemsNode.querySelectorAll('[data-remove-key]').forEach(button => button.addEventListener('click', async () => {
        button.disabled = true;
        try {
          const updated = await cartService.remove(button.dataset.removeKey);
          renderCart(updated);
          await refreshCartPage(true);
        } catch (error) { button.disabled = false; cartError(error); }
      }));
      return cart;
  }

  function refreshCartPage(force = false) {
    const task = async () => {
      const page = document.querySelector('[data-cart-page]');
      if (!page || (!force && (!window.Zenbar?.guideId || page.dataset.guidePresent === 'true'))) return;
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', page.dataset.sectionId);
      const response = await fetch(url.href, { cache: 'no-store' });
      if (!response.ok) throw new Error('Please refresh your bag to see the latest items.');
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const updatedPage = documentFragment.querySelector('[data-cart-page]');
      if (!updatedPage) throw new Error('Please refresh your bag to see the latest items.');
      page.replaceWith(updatedPage);
    };
    cartPageQueue = cartPageQueue.catch(() => {}).then(task);
    return cartPageQueue;
  }

  async function refreshCart(forcePage = false) {
    const cart = await cartService.sync();
    renderCart(cart);
    await refreshCartPage(forcePage);
    return cart;
  }

  // Keep the full basket in sync and wait for the real guide line before checkout.
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.cart-page__form');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.cartGuideBusy === 'true') return;
    const checkout = event.submitter?.name === 'checkout';
    const updates = {};
    for (const [name, value] of new FormData(form)) {
      const match = /^updates\[(.+)\]$/.exec(name);
      if (match) updates[match[1]] = Math.max(0, Math.floor(Number(value) || 0));
    }
    form.dataset.cartGuideBusy = 'true';
    form.querySelectorAll('button').forEach(button => { button.disabled = true; });
    try {
      const cart = await cartService.update(updates);
      renderCart(cart);
      if (checkout && !cartService.hasPaidProduct(cart)) {
        showToast('Add a crystal to your bag to receive the complimentary guide.');
        await refreshCartPage(true);
        return;
      }
      if (checkout) window.location.assign(routeRoot + 'checkout');
      else await refreshCartPage(true);
    } catch (error) { cartError(error); }
    finally {
      form.dataset.cartGuideBusy = 'false';
      form.querySelectorAll('button').forEach(button => { button.disabled = false; });
    }
  });

  document.addEventListener('click', async event => {
    const remove = event.target.closest('[data-cart-page-remove]');
    if (!remove) return;
    event.preventDefault();
    if (remove.dataset.cartGuideBusy === 'true') return;
    remove.dataset.cartGuideBusy = 'true';
    try {
      const cart = await cartService.remove(remove.dataset.cartPageRemove);
      renderCart(cart);
      await refreshCartPage(true);
    } catch (error) { remove.dataset.cartGuideBusy = 'false'; cartError(error); }
  });

  document.querySelectorAll('[data-quick-add]').forEach(button => button.addEventListener('click', async event => {
    event.preventDefault();
    event.stopPropagation();
    if (button.disabled) return;
    if (Number(button.dataset.variantId) === Number(window.Zenbar?.guideId)) {
      showToast('The complimentary guide is included automatically with a purchase.');
      openCart();
      return;
    }
    button.disabled = true;
    try {
      const cart = await cartService.add({ items:[{ id:Number(button.dataset.variantId), quantity:1 }] });
      showToast(`${button.dataset.productTitle || 'Crystal'} added to bag`);
      renderCart(cart);
      await refreshCartPage(true);
      openCart();
    } catch (error) {
      showToast('This piece could not be added. Please open the product page.');
    } finally { button.disabled = false; }
  }));

  document.querySelectorAll('form.product-form').forEach(form => form.addEventListener('submit', async event => {
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    if (submit?.disabled) return;
    const formData = new FormData(form);
    if (Number(formData.get('id')) === Number(window.Zenbar?.guideId)) {
      showToast('The complimentary guide is included automatically with a purchase.');
      openCart();
      return;
    }
    if (submit) submit.disabled = true;
    try {
      const cart = await cartService.add(formData);
      showToast('Added to your bag');
      renderCart(cart);
      await refreshCartPage(true);
      openCart();
    } catch (error) {
      showToast('This piece could not be added. Please try again.');
    } finally { if (submit) submit.disabled = false; }
  }));

  window.addEventListener('pageshow', event => { if (event.persisted) refreshCart(true).catch(cartError); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refreshCart(true).catch(cartError); });
  refreshCart().catch(cartError);
});
